import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorContent } from './ErrorContent';

export const PageNotFound: React.FC = () => {
  const { t } = useTranslation('errors');

  return (
    <ErrorContent
      title={t('page_not_found_title', '404: Page not found')}
      description={t(
        'page_not_found_message',
        'Sorry, we cannot find the page you are looking for.'
      )}
    ></ErrorContent>
  );
};
